import script from "./activityDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./activityDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./activityDetailPage.vue?vue&type=style&index=0&id=365b82a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365b82a2"]])

export default __exports__